import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import AdminNavSegmented from "components/admin/nav-segmented"
import classNames from "classnames"
import {Course} from "models"
import memo from "set-state-compare/src/memo"
import PropTypes from "prop-types"
import Routes from "shared/routes"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

export default memo(shapeComponent(class RoutesAdminCoursesNav extends ShapeComponent {
  static propTypes = {
    active: PropTypes.string,
    className: PropTypes.string,
    course: PropTypes.instanceOf(Course).isRequired
  }

  setup() {
    const {locale, t} = useI18n({namespace: "js.components.admin.courses.nav"})
    const {course} = this.p

    this.t = t
    this.buttons = useMemo(
      () => [
        {
          value: "general",
          label: this.t("js.shared.general"),
          to: Routes.adminCoursePath(course.id())
        },
        {
          value: "course-modules",
          label: `${Course.humanAttributeName("courseModules")} (${course.courseModulesCount()})`,
          to: Routes.adminCourseCourseModulesPath(course.id())
        }
      ],
      [locale]
    )
  }

  render() {
    const {active, className, course, ...restProps} = this.props

    return (
      <AdminNavSegmented
        active={active}
        buttons={this.tt.buttons}
        dataSet={{class: classNames("routes--admin--courses--nav", className)}}
        {...restProps}
      />
    )
  }
}))
